import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {CompletedEventSummaryModel} from "../models/completed-event/completed-event-summary.model";
import { CompletedEventExtractedCertificate } from '../models/completed-event/completed-event-extracted-certificate.model';
import {Configuration} from "../../assets/Configuration";
import {DownloadService} from "./download.service";
import {RawFileModel} from "../models/raw-file-model"

@Injectable({
  providedIn: 'root'
})
export class CompletedEventService {

  constructor(private httpClient: HttpClient, private downloadService: DownloadService) {
  }

  public getAllCompletedEvents(personId: string): Observable<CompletedEventSummaryModel[]> {
    const params = new HttpParams()
      .set('personId', personId);
      
    return this.httpClient.get<CompletedEventSummaryModel[]>(
      Configuration.getApiBaseUrl() + "/completedevent",
      { params: params }
    );
  }

  public downloadCompletedEventMemberListByTrainingId(trainingId: string): void {
    const params = new HttpParams()
      .set('trainingId', trainingId);

    this.downloadService.download(
      Configuration.getApiBaseUrl() + "/completedevent/member-list/by-training-id",
      params
    );
  }

  public extractCertificateFile(model: RawFileModel): Observable<CompletedEventExtractedCertificate> {
    return this.httpClient.post<CompletedEventExtractedCertificate>(Configuration.getApiBaseUrl() +  '/completedevent/extract-certificate-file', model);
  }

  public getEventCompletedMembers(trainingId: string): Observable<void> {
    const params = new HttpParams()
      .set('trainingId', trainingId);

    return this.httpClient.get<void>(
      Configuration.getApiBaseUrl() +  "/completedevent/persons/by-training-id",
      { params: params }
    );
  }
}
